const __WEBPACK_NAMESPACE_OBJECT__ = require("react-quill/dist/quill.snow.css");